import { registerErrorInterceptor, registerResponseInterceptor } from '../api';
import { Sentry } from '@gogame/components';

const ignoreList = [
  '/api/auth/current',
  '/api/profile/favorite-menu',
  '/api/profile/subscriptions/grid',
  '/api/common/system-messages',
  '/api/profile/notifications',
  '/api/auth/permissions',
];

registerResponseInterceptor((response) => {
  if (!ignoreList.some((url) => response.config.url.includes(url))) {
    Sentry.addBreadcrumb({
      type: 'http',
      category: 'xhr',
      data: {
        url: response.request.responseURL,
        method: response.config.method.toUpperCase(),
        status_code: response.status,
        reason: response.statusText,
        data: response.data,
      },
    });
  }

  return response;
}, 'Sentry');

registerErrorInterceptor(async (error) => {
  if (!ignoreList.some((url) => error.url.includes(url))) {
    Sentry.addBreadcrumb({
      type: 'http',
      category: 'xhr',
      data: {
        url: error.url,
        method: error?.method.toUpperCase(),
        status_code: error?.status,
        reason: error?.statusText,
        data: error?.response,
      },
    });
  }
  return error;
}, 'Sentry');
